import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import AnimacionCarga from "../pages/components/animacion_de_carga";
import InicioDeSesion from '../pages/components/inicio_de_sesion';
import Registro from '../pages/components/registro';
import PaginaNoEncontrada from '../pages/components/pagina_no_encontrada';
import Inicio2 from "../pages/components/inicio_2";
import ListadoDeTickets from "../pages/components/listado_tickets";
import EstadisticaTickets from "../pages/components/estadistica_tickets";
import CategoriasTickets from "../pages/components/tickets/listado_categorias";
import UsuariosTickets from "../pages/components/tickets/listado_usuarios";
import ListadoVisitantes from "../pages/components/listado_visitantes";
import ListadoEncomiendas from "../pages/components/listado_encomiendas";
import ListadoPqrs from "../pages/components/listado_pqrs";
import ListadoNoticias from "../pages/comunicaciones/listado_noticias";
import Panico from "../pages/comunicaciones/panico";
import ListadoAnuncios from "../pages/comunicaciones/listado_anuncios";
import MisAnuncios from "../pages/comunicaciones/mis_anuncios";
import ListadoNotificaciones from "../pages/comunicaciones/listado_notificaciones";
import ListadoNovedades from "../pages/components/listado_novedades";
import ListadoUsuarios from "../pages/components/listado_usuarios";
import ListadoReservas from "../pages/components/listado_reservas";
import ListadoClientes from "../pages/components/listado_clientes";
import ListadoRondas from "../pages/components/listado_rondas";
import ListadoTutoriales from "../pages/components/listado_tutoriales";
import ListadoGPS from "../pages/components/super/listado_gps";
import ListadoEventos from "../pages/components/listado_eventos";
import Estadistica from "../pages/components/estadistica";
import ListadoSOS from "../pages/components/sos/listado_sos";
import VigilanteSOS from "../pages/components/sos/vigilante_sos";
import ModuloSOSPrueba from "../pages/components/sos/modulo_sos_prueba";
import ListadoInmuebles from "../pages/components/listado_inmuebles";
import Seguimiento from "../pages/components/seguimiento";
import ListadoCenso from "../pages/components/censo/listado_censo";
import InformesCenso from "../pages/components/censo/listado_informe_censo";
import EstadisticaCenso from "../pages/components/censo/estadistica_censo";
import ListadoRaiting from "../pages/components/super/listado_rating";
import ListadoLogs from "../pages/components/logs/listado_logs";
import EstadisticaLogs from "../pages/components/logs/graficas_log";
import ListadoPqrsRespuesta from "../pages/components/listado_respuestas_pqrs";
import ListadoCartera from "../pages/components/listado_cartera";
import CarteraResidente from "../pages/components/cartera_residente";
import UnidadesDeViviendaGrafica from "../pages/components/unidades_grafica";
import AnalisisRondas from "../pages/components/analisis_rondas";
import ListadoActividades from "../pages/components/actividades/ListadoActividades";
import EstadisticasActividades from "../pages/components/actividades/EstadisticaActividades";
import ListadoZonas from "../pages/components/listado_zonas";
import Legal from "../pages/components/legal";
import PerfilCopropiedad from "../pages/components/perfil_copropiedad";
import CobroParqueaderos from "../pages/components/cobro_parqueaderos";
import ConfiguracionModulos from "../pages/components/configuracion_modulos";
import ReservasWeb from "../pages/components/reservas/ReservasWeb";
import CorreosExcluidos from "../pages/components/correos_excluidos";
import InmueblesAdministrativos from "../pages/components/inmuebles_administrativos";
import ListadoDocumentos from "../pages/components/listado_documentos";
import ListadoChats from "../pages/components/listado_chats";
import MiPropiedad from "../pages/components/mi_propiedad";
import ConfiguracionesGlobales from "../pages/components/super/configuraciones_globales";
import CuentaCorreo from "../pages/components/super/cuenta_correo";
import Fiesta from "../pages/components/super/fiesta";
import EstadisticaFiesta from "../pages/components/super/estadistica_fiesta";
import { obtenerTitulo } from "./titulos_paginas";

const TituloDePagina = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = obtenerTitulo(pathname);
  }, [pathname]);

  return null;
};

const ProtectedRoute = ({ children }) => {
  const { usuario, cargando } = useAuth();

  if (cargando) return <AnimacionCarga />;
  if (!usuario) return <Navigate to="/" replace />;

  return children;
};

// Todo lo del menú SOPORTE es sólo para usuarios SUPER: si otro rol escribe la
// dirección a mano, vuelve al inicio.
const SoloSuperRoute = ({ children }) => {
  const { usuario, cargando } = useAuth();

  if (cargando) return <AnimacionCarga />;
  if (!usuario) return <Navigate to="/" replace />;
  if (localStorage.getItem("Permisos") !== "SUPER") return <Navigate to="/inicio" replace />;

  return children;
};

function GestionDeRutas() {
  return (
    <BrowserRouter>
      <TituloDePagina />

      <VigilanteSOS />

      <Routes>
        <Route path="" element={<InicioDeSesion />} />
        <Route path="*" element={<PaginaNoEncontrada />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/legal" element={<Legal />} />

        <Route path="/inicio" element={<ProtectedRoute><Inicio2 /></ProtectedRoute>} />
        <Route path="/tickets" element={<SoloSuperRoute><ListadoDeTickets /></SoloSuperRoute>} />
        <Route path="/tickets_categorias" element={<SoloSuperRoute><CategoriasTickets /></SoloSuperRoute>} />
        <Route path="/tickets_usuarios" element={<SoloSuperRoute><UsuariosTickets /></SoloSuperRoute>} />
        <Route path="/estadistica_tickets" element={<ProtectedRoute><EstadisticaTickets /></ProtectedRoute>} />
        <Route path="/visitantes" element={<ProtectedRoute><ListadoVisitantes /></ProtectedRoute>} />
        <Route path="/encomiendas" element={<ProtectedRoute><ListadoEncomiendas /></ProtectedRoute>} />
        <Route path="/pqrs" element={<ProtectedRoute><ListadoPqrs /></ProtectedRoute>} />
        <Route path="/noticias" element={<ProtectedRoute><ListadoNoticias /></ProtectedRoute>} />
        <Route path="/anuncios" element={<ProtectedRoute><ListadoAnuncios /></ProtectedRoute>} />
        <Route path="/mis_anuncios" element={<ProtectedRoute><MisAnuncios /></ProtectedRoute>} />
        <Route path="/notificaciones" element={<ProtectedRoute><ListadoNotificaciones /></ProtectedRoute>} />
        <Route path="/novedades" element={<ProtectedRoute><ListadoNovedades /></ProtectedRoute>} />
        <Route path="/usuarios" element={<ProtectedRoute><ListadoUsuarios /></ProtectedRoute>} />
        <Route path="/censo" element={<ProtectedRoute><ListadoCenso /></ProtectedRoute>} />
        <Route path="/reservas" element={<ProtectedRoute><ListadoReservas /></ProtectedRoute>} />
        <Route path="/clientes" element={<SoloSuperRoute><ListadoClientes /></SoloSuperRoute>} />
        <Route path="/rondas" element={<ProtectedRoute><ListadoRondas /></ProtectedRoute>} />
        <Route path="/tutoriales" element={<ProtectedRoute><ListadoTutoriales /></ProtectedRoute>} />
        <Route path="/gps" element={<ProtectedRoute><ListadoGPS /></ProtectedRoute>} />
        <Route path="/eventos" element={<ProtectedRoute><ListadoEventos /></ProtectedRoute>} />
        <Route path="/estadistica" element={<ProtectedRoute><Estadistica /></ProtectedRoute>} />
        <Route path="/seguimiento" element={<ProtectedRoute><Seguimiento /></ProtectedRoute>} />
        <Route path="/sos" element={<ProtectedRoute><ListadoSOS /></ProtectedRoute>} />
        <Route path="/sos_prueba" element={<ProtectedRoute><ModuloSOSPrueba /></ProtectedRoute>} />
        <Route path="/panico" element={<ProtectedRoute><Panico /></ProtectedRoute>} />
        <Route path="/inmuebles" element={<ProtectedRoute><ListadoInmuebles /></ProtectedRoute>} />
        <Route path="/informe_censo" element={<ProtectedRoute><InformesCenso /></ProtectedRoute>} />
        <Route path="/estadistica_censo" element={<ProtectedRoute><EstadisticaCenso /></ProtectedRoute>} />
        <Route path="/rating" element={<ProtectedRoute><ListadoRaiting /></ProtectedRoute>} />
        <Route path="/logs" element={<SoloSuperRoute><ListadoLogs /></SoloSuperRoute>} />
        <Route path="/logs_grafica" element={<ProtectedRoute><EstadisticaLogs /></ProtectedRoute>} />
        <Route path="/detalle_pqrs" element={<ProtectedRoute><ListadoPqrsRespuesta /></ProtectedRoute>} />
        <Route path="/cartera" element={<ProtectedRoute><ListadoCartera /></ProtectedRoute>} />
        <Route path="/mi_cartera" element={<ProtectedRoute><CarteraResidente /></ProtectedRoute>} />
        <Route path="/unidades_vivienda" element={<ProtectedRoute><UnidadesDeViviendaGrafica /></ProtectedRoute>} />
        <Route path="/analisis_rondas" element={<ProtectedRoute><AnalisisRondas /></ProtectedRoute>} />
        <Route path="/actividades" element={<ProtectedRoute><ListadoActividades /></ProtectedRoute>} />
        <Route path="/estadistica_actividades" element={<ProtectedRoute><EstadisticasActividades /></ProtectedRoute>} />
        <Route path="/zonas_sociales" element={<ProtectedRoute><ListadoZonas /></ProtectedRoute>} />
        <Route path="/perfil_copropiedad" element={<ProtectedRoute><PerfilCopropiedad /></ProtectedRoute>} />
        <Route path="/cobro_parqueaderos" element={<ProtectedRoute><CobroParqueaderos /></ProtectedRoute>} />
        <Route path="/configuracion_modulos" element={<ProtectedRoute><ConfiguracionModulos /></ProtectedRoute>} />
        <Route path="/crear_reserva" element={<ProtectedRoute><ReservasWeb /></ProtectedRoute>} />
        <Route path="/correos_excluidos" element={<SoloSuperRoute><CorreosExcluidos /></SoloSuperRoute>} />
        <Route path="/inmuebles_administrativos" element={<SoloSuperRoute><InmueblesAdministrativos /></SoloSuperRoute>} />
        <Route path="/documentos" element={<ProtectedRoute><ListadoDocumentos /></ProtectedRoute>} />
        <Route path="/chats" element={<ProtectedRoute><ListadoChats /></ProtectedRoute>} />
        <Route path="/mi_propiedad" element={<ProtectedRoute><MiPropiedad /></ProtectedRoute>} />
        <Route path="/configuraciones_globales" element={<SoloSuperRoute><ConfiguracionesGlobales /></SoloSuperRoute>} />
        <Route path="/cuenta_correo" element={<SoloSuperRoute><CuentaCorreo /></SoloSuperRoute>} />
        <Route path="/fiesta" element={<SoloSuperRoute><Fiesta /></SoloSuperRoute>} />
        <Route path="/estadistica_fiesta" element={<ProtectedRoute><EstadisticaFiesta /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default GestionDeRutas;
